import { render, staticRenderFns } from "./ReportsDetailDesktop.vue?vue&type=template&id=802a7aba"
import script from "./ReportsDetailDesktop.vue?vue&type=script&lang=js"
export * from "./ReportsDetailDesktop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports